export const HEIGHT = 42;
export const INNER_HEIGHT = 42;

export function getXPositionFromStep(step, resolution, zoom=1) {
    let ratio = resolution.resolution / 8;
    return zoom * ratio * 100 * step / 32;
}

export function getYPositionFromVolume(volume) {
    return HEIGHT - volume * INNER_HEIGHT;
}

export function getValueFromYPosition(position) {
    return Math.max(0, Math.min(1, (HEIGHT  - position) / INNER_HEIGHT));
}

